// import { store } from "../../../config/store";
// import Questions from "./questions.json";
// import woQuestions from "./withoutquestion.json";
import { push } from "connected-react-router";
import Moment from "moment";
// import JsnValidate from "./validate.json";
// import apiConfig from "../../../config/api";
import {
  validateRutApi,
  validateEmailApi,
  doValidateSerivice,
  createUserAdApi,
  validateRutTemp,
  validateEmailTemp,
  conditionAcept,
  createTempUserApi,
  createUserAdWithRolesApi,
  assignAdminCompanyRolesToUser,
  doCotizacionesService,
} from "../../../services/registroApi";
import trace from "../../../helpers/trace";
import validaciones from "../../../helpers/validaciones";
import { loading, openCloseToast, sendEmailApp } from "../../Global/actions";
import constants from "../../../helpers/constants";
import { createRolesForUser } from "../../../services/userRolesApi";
import {
  getQuestionsApi,
  verifyAnswersApi,
} from "../../../services/equifaxApi";
import { sendSMS } from "../../../services/smsApi";
import UserInfo from "../../SucursalVirtual/Trabajador/Solicitudes/SolicitudesPendientes/userInfo";
import { EnvioEmailSMSActivacionCuenta } from "../RecuperarPassword/actions";
import { envioEmailSMSActivacionCuenta } from "../../../services/ValidacionIdentidad";
import { createSolicitudADApi } from '../../../services/solicitudesApi';
export const userRegisterStep = (steps) => ({
  type: "USER_REGISTER_STEP",
  steps,
});
export const setUserInfo = (UserInfo) => ({
  type: "SET_USER_INFO",
  UserInfo,
});
export const cleanRegisterStep = () => ({
  type: "CLEAN_REGISTER_STEP",
});
export const setQuestionsLoad = (QuestionsList) => ({
  type: "SET_QUESTIONS_LOAD",
  QuestionsList,
});

export const setMessageCreateUser = (messageCreateUser) => ({
  type: "SET_MESSAGE_CREATE_USER",
  messageCreateUser,
});
export const setMessageAnswers = (messageQuestions) => ({
  type: "SET_MESSAGE_ANSWERS",
  messageQuestions,
});
export const setValidRut = (rutValid) => ({
  type: "SET_VALID_RUT",
  rutValid,
});
export const setValidEmail = (emailValid) => ({
  type: "SET_VALID_EMAIL",
  emailValid,
});
export const setValidNSerieCI = (isValid) => ({
  type: "SET_VALID_N_SERIE_CI",
  isValid,
});
export const setSkipValidation = (skipValidation) => ({
  type: "SET_SKIPVALIDATION",
  skipValidation,
});

export const setFileUrl = (fileUrl) => ({
  type: "SET_FILE_URL",
  fileUrl,
});

export const setEmailActivationADInfo = (mailData) => ({
  type: "SET_EMAIL_ACTIVATION_AD_INFO",
  mailData,
});

export const loadingRecover = (isLoading) => ({
  type: "LOADING_RECUPERAR_PASSWORD",
  isLoading,
});

/**
 * @param {*} personalData: Es el state de la vista con los datos del formulario
 * ingresados por el usuario para el registro
 */
export const doValidateEmailRut = (personalData) => async (dispatch) => {
  dispatch(loading(true));
  const toast = {};
  try {
    let resultRut;
    let resultRutTemp;
    let validRutApi;
    let validRutTemp;
    let resultEmailApi;
    let resultEmailTemp;
    let validEmailApi;
    let validEmailTemp;
    const rut = validaciones.formatRut(personalData.rutUsuario, {
      showDots: false,
      showHyphen: true,
    });

    //Busca el usuario por RUT en el Azure B2C con el MS-User api/user/rut/{rutUsuario}
    const responseRut = await validateRutApi(rut);

    /**
     * Buscar el usuario en base de datos por RUT en la tabla TempUsers
     * en api/temp/user/rut/{rutUsuario} en MS-User-Temp
     */
    const responseRutTemp = await validateRutTemp(rut);

    if (responseRut.ok) {
      resultRut = await responseRut.json();
      validRutApi = resultRut.Success;
    } else {
      validRutApi = false;
    }
    if (responseRutTemp.ok) {
      resultRutTemp = await responseRutTemp.json();
      validRutTemp = resultRutTemp.Success;
    } else {
      validRutTemp = false;
    }

    /**
     * Sì el RUT del usuario no existe en B2C ni en Base de datos,
     * busca el email en B2C y en Base de datos
     */
    if (validRutTemp === false && validRutApi === false) {
      //Busca el usuario por Email en el Azure B2C con el MS-User api/user/email/{emailUsuario}
      const responseEmail = await validateEmailApi(personalData.email);
      /**
       * Buscar el usuario en base de datos por Email en la tabla TempUsers
       * en api/temp/user/email/{email} en MS-User-Temp
       */
      const responseEmailTemp = await validateEmailTemp(personalData.email);

      if (responseEmail.ok) {
        resultEmailApi = await responseEmail.json();
        validEmailApi = resultEmailApi.Success;
      } else {
        validEmailApi = false;
      }
      if (responseEmailTemp.ok) {
        resultEmailTemp = await responseEmailTemp.json();
        validEmailTemp = resultEmailTemp.Success;
      } else {
        validEmailTemp = false;
      }
      /**
       * Sì el email del usuario no existe en base de datos y tampoco
       * existe en Azure B2C, entonces realiza la validaciones para registrar
       */
      if (validEmailTemp === false && validEmailApi === false) {
        /**
         * Llamada para validar y completar los datos del usuario,
         * asi como validar RUT y Numero de serie con Equifax
         */
        await dispatch(doValidate(personalData));
      } else {
        /**Sì existe el email, setea el state como email valido
         * y no permite registrar al usuario porque ya existe
         */
        dispatch(setValidEmail(true));
      }
    } else {
      /**Sì existe el rut del usuario, setea el state como rut valido
       * y no permite registrar porque ya existe
       */
      dispatch(setValidRut(true));
    }
  } catch (error) {
    toast.isToastOpen = true;
    toast.msgToast = "Error de conexión, intente más tarde";
    toast.typeStyle = "error";
    toast.displayTime = 5000
    dispatch(openCloseToast(toast));
  }
  dispatch(loading(false));
};

/**
 *
 * @param {*} UserInfo : Objeto con los datos personales del usuario y con la lista de roles
 * @param {*} firstTime : Asume que es la primera vez que el usuario ingresa
 */
export const validateCI = (UserInfo, firstTime = true) => async (dispatch) => {
  dispatch(loading(true));
  const toast = {};
  try {
    //Formatea el RUT
    const rut = validaciones.formatRut(UserInfo.Rut, {
      showDots: false,
      showHyphen: true,
    });

    /**
     * Consulta la API de Equifax para validar RUT y numero de serie,
     * consulta la API,  api/equifax/questions/{rutUsuario}/{serieCI} MS-User
     */

    const response = await getQuestionsApi(rut, UserInfo.serieCI);

    /**
     * Sì la consulta a Equifax es satisfactoria activa el render de la siguiente pantalla,
     * donde muestra para los datos personales completados y pide el telefono
     */
    if (response.status === 200) {
      const result = await response.json();
      const skipValidation = result.ErrorMessage ? false : true;

      if (result.QuestionsList.length > 0 || skipValidation) {
        const steps = {
          stepOne: false,
          stepTwo: false,
          stepThree: true, // Redirige a la pantalla ValidarDatosPersonales
          stepFour: false,
          stepSuccess: false,
        };
        dispatch(userRegisterStep(steps));
        dispatch(setMessageAnswers(null));
      } else {
        //Sì la consulta a Equifax no es satisfactoria, devuelve a la primera pantalla (Aceptar condiciones)
        dispatch(
          userRegisterStep({
            stepOne: true,
            stepTwo: false,
            stepThree: false,
            stepFour: false,
            stepSuccess: false,
          })
        );
        toast.isToastOpen = true;
        toast.msgToast = result.ErrorMessage
          ? result.ErrorMessage
          : "La cédula ingresada se encuentra bloqueada, expirada o no vigente, por favor, verifique sus datos.";
        toast.typeStyle = "error";
        toast.displayTime = 5000
        dispatch(openCloseToast(toast));
      }
    } else if (response.status === 400) {
      const result = await response.json();
      toast.msgToast = result.Message;
      toast.isToastOpen = true;
      toast.typeStyle = "error";
      toast.displayTime = 5000
      dispatch(openCloseToast(toast));
      dispatch(setValidNSerieCI(false));
      dispatch(
        userRegisterStep({
          stepOne: true,
          stepTwo: false,
          stepThree: false,
          stepFour: false,
        })
      );
    } else if (response.status === 500) {
      dispatch(setValidNSerieCI(false));
      dispatch(
        userRegisterStep({
          stepOne: true,
          stepTwo: false,
          stepThree: false,
          stepFour: false,
        })
      );
      toast.isToastOpen = true;
      toast.msgToast = "Error de conexión, intente más tarde";
      toast.typeStyle = "error";
      toast.displayTime = 5000
      dispatch(openCloseToast(toast));
    }
    //Aparece cuando no se puede validar carnet de identidad con Equifax porque els ervicio bloqueo al usuario
    else if (response.status === 401) {
      dispatch(setValidNSerieCI(false));
      dispatch(
        userRegisterStep({
          stepOne: true,
          stepTwo: false,
          stepThree: false,
          stepFour: false,
        })
      );
      toast.isToastOpen = true;
      toast.msgToast =
        "Error al validar carnet de identidad, credenciales invalidades";
      toast.typeStyle = "error";
      toast.displayTime = 5000
      dispatch(openCloseToast(toast));
    }
  } catch (error) {
    dispatch(setValidNSerieCI(false));
    trace.information("ERROR", error);
    toast.isToastOpen = true;
    toast.msgToast = "Error de conexión, intente más tarde";
    toast.typeStyle = "error";
    toast.displayTime = 5000
    dispatch(openCloseToast(toast));
  }
  dispatch(loading(false));
};

/**
 *
 * @param {*} personalData: Datos del usuario ingresados en  formulario, representa
 * el state de la vista de datos personales
 */
export const doValidate = (personalData) => async (dispatch) => {
  const toast = {};
  try {
    /**
     * UserInfo: Objeto para almacenar los datos personales que devuelve
     * el servicio de cotizaciones, BP y DatosPersonales Middleware ACHS
     */
    const UserInfo = {};
    let TempBD;
    const rut = validaciones.formatRut(personalData.rutUsuario, {
      showDots: false,
      showHyphen: true,
    });

    /**
     * Toma la fecha actual y resta 2 meses para setear el periodo de cotizaciones
     * , este periodo de cotizaciones debe ser minimo 2 meses antes
     */
    const periodo = Moment(new Date()).subtract(2, "months").format("YYYYMM");

    /**
     * Valida sì el usuario tiene cotizaciones en ACHS al menos
     * 2 meses antes de la fecha actual, consulta la API api/user/validate/{rutUsuario}/{periodo}
     * en MS-User
     * Devuelve la informaciòn personal del usuaruio, el rut de la empresa, lista de roles
     */

    const response = await doValidateSerivice(rut, periodo);

    if (response.ok) {
      const result = await response.json(); // JsnValidate;
      if (result.IsActive) {
        TempBD = false;
        UserInfo.Rol = result.Rol.Id;
        if (result.Rol.Code === constants.codeRolExACHS)
          UserInfo.IsExACHS = true;
      } else {
        // temp users -> ex achs rol (8)
        TempBD = false;
        UserInfo.Rol = constants.idRolExACHS;
        UserInfo.IsExACHS = true;
      }
      // Mapear datos de objetos personalData y result(respuesta de doValidateSerivice(rut, periodo))
      UserInfo.Email = personalData.email;
      UserInfo.Rut = personalData.rutUsuario;
      UserInfo.serieCI = personalData.serieCI;
      UserInfo.TempBD = TempBD;
      UserInfo.RelationType = TempBD === false ? "INT" : null;
      UserInfo.FirstName =
        result.UserInfo !== null ? result.UserInfo.FirstName : null;
      UserInfo.MiddleName =
        result.UserInfo !== null ? result.UserInfo.MiddleName : null;
      UserInfo.LastName =
        result.UserInfo !== null ? result.UserInfo.LastName : null;
      UserInfo.MothersName =
        result.UserInfo !== null ? result.UserInfo.MothersName : null;
      UserInfo.BirthDate =
        result.UserInfo !== null ? result.UserInfo.BirthDate || null : null;
      UserInfo.CompanyRut = result.CurrentCompanyRut;
      //En personalData no viene el campo phone y se esta seteando nulo
      UserInfo.Phone = validaciones.validateCellPhone(personalData.phone)
        ? personalData.phone
        : null;

      // Almacena en los datos del usuario en Redux Store
      // sessionStorage.setItem("serieCI", UserInfo.serieCI);
      // sessionStorage.setItem("rut", rut);
      dispatch(setUserInfo(UserInfo));

      // Skip step three
      //Consulta el servicio de Equifax para validar el RUT y el numero de serie
      await dispatch(validateCI(UserInfo));
    } else {
      throw new Error(response.status);
    }
  } catch (error) {
    trace.information("ERROR", error);
    toast.isToastOpen = true;
    toast.msgToast = "Error de conexión, intente más tarde";
    toast.typeStyle = "error";
    toast.displayTime = 5000
    dispatch(openCloseToast(toast));
  }
};

/**
 * Setea que se han aceptado los terminos y condiciones
 * @param {*} UserInfo: Información personal del usuario ingresada
 * en los formularios
 */
export const doConditions = (UserInfo) => async (dispatch) => {
  const toast = {};
  try {
    //Formatea el RUT sin puntos y con guion
    const rut = validaciones.formatRut(UserInfo.Rut, {
      showDots: false,
      showHyphen: true,
    });

    /**
     * Setea que el usuario ha aceptado los terminos y condiciones,
     * consume el servicio api/user/termsandconditionsacceptance
     * realiza un insert en la tabla TermsAndConditionsAcceptance
     */
    // const response = await conditionAcept(rut);

    // if (response.ok) {
    //   trace.information("Pasó término y condiciones");
    // } else if (response.status === 400) {
    //   trace.information("El rut ya ha aceptado los términos y condiciones");
    // } else if (response.status === 500) {
    //   toast.isToastOpen = true;
    //   toast.msgToast =
    //     "Error de conexión Términos y condiciones, intente más tarde";
    //   toast.typeStyle = "error";
    //   dispatch(openCloseToast(toast));
    // }
  } catch (error) {
    toast.isToastOpen = true;
    toast.msgToast =
      "Error de conexión Términos y condiciones, intente más tarde";
    toast.typeStyle = "error";
    toast.displayTime = 5000
    dispatch(openCloseToast(toast));
  }
};

export const doCreateUserTempBD = (personalData, paths) => async (dispatch) => {
  const toast = {};
  dispatch(loading(true));
  try {
    const steps = {
      stepOne: false,
      stepTwo: false,
      stepThree: false,
      stepFour: false,
      stepSuccess: false,
    };
    personalData.Birthdate = validaciones.sendDateFormatApis(
      personalData.Birthdate
    );
    personalData.Rut = validaciones.formatRut(personalData.Rut, {
      showDots: false,
      showHyphen: true,
    });

    const response = await createTempUserApi(personalData);
    if (response.ok) {
      await dispatch(doConditions(personalData));

      dispatch(userRegisterStep(steps));
      dispatch(push(paths));
    } else {
      dispatch(setMessageCreateUser(response.status));
    }
  } catch (error) {
    trace.information("ERROR", error);
    toast.isToastOpen = true;
    toast.msgToast = "Error de conexión, intente más tarde";
    toast.typeStyle = "error";
    toast.displayTime = 5000
    dispatch(openCloseToast(toast));
  }
  dispatch(loading(false));
};

/**
 * Metodo para crear al nuevo usuario en Azure B2C
 * @param {*} userRegister: Datos personales del usuario desse Redux Store UserInfo
 */
export const createUserAD = (userRegister) => async (dispatch) => {
  dispatch(loading(true));
  const toast = {};
  try {
    /**
     * Objeto para setear la redirección a las
     * distintas pantallas del flujo de registro
     */
    const steps = {
      stepOne: false,
      stepTwo: false,
      stepThree: false,
      stepFour: false,
      stepSuccess: false, //Setea la redirección para la pantalla final de sucess
      stepSix: true, //Redireccion a la nueva pantalla de reenvio de link
    };

    //Formatea la fecha de nacimiento del usuario
    userRegister.Birthdate = validaciones.sendDateFormatApis(
      userRegister.BirthDate
    );
    let response;

    //Formatea el rut del usuario sin puntos y con guion para enviarlo al backend
    userRegister.Rut = validaciones.formatRut(userRegister.Rut, {
      showDots: false,
      showHyphen: true,
    });

    /**
     * Setea que el usuario ha aceptado los terminos y condiciones
     */
    await dispatch(doConditions(userRegister));
    //Si el usuario es externo ACHS
    if (userRegister.IsExACHS) {
      /**
       *  Creación del usuario IsExACHS en Azure B2C y en Base de datos
       *  consume el servicio api/user/create
       */
      response = await createUserAdApi(userRegister);
    } else {
      //Si el usuario tiene otro role
      userRegister.IdRoles = [userRegister.Rol];
      userRegister.IsAchsWorker = false;
      /**
       * Valida sí el usuario es trabajador ACHS y setea
       *   userRegister.IsAchsWorker = true;
       */
      if (userRegister.CompanyRut === constants.achsRut) {
        userRegister.IsAchsWorker = true;
      }
      /**
       * Crear el usuario con roles, consume el la API api/user/createwithroles
       * del serivicio MS-User
       */

      response = await createUserAdWithRolesApi(userRegister);

      if(userRegister.companyRut!==''){
        //Validar cotizaciones
        const responseDatosUsuario = await (await doCotizacionesService()).json();
        if(responseDatosUsuario.CompanyRut !== userRegister.companyRut) {
          //En caso de no cotizar se debe registrar la solicitud
          await createSolicitudADApi(userRegister.Rut, userRegister.companyRut, 'descripcion ...', 'PER_TRABAJADOR', 6)
        }
      }
    }

    const result = await response.json();

    if (response.status === 200) {
      if (result.Success) {
        //Sí el usuario es externo ACHS
        if (userRegister.IsExACHS) {
          /**
           * Consume el servicio api/accessmanagement/assignment/rol/user/create
           * para crear el role del usuario
           */
          await createRolesForUser(userRegister.Rut, [userRegister.Rol]);

          // buscar si es admin en otras empresas y asignarlas al usuario como admin
          await assignAdminCompanyRolesToUser(userRegister.Rut);
        }

        //Envio Email/SMS por backend
        dispatch(
          EnvioEmailSMSActivacionCuenta(
            {
              Phone: userRegister.Phone,
              Email: userRegister.Email,
              NotificationType: 3,
            },
            null,
            envioEmailSMSActivacionCuenta
          )
        );

        //Guarda la redirección a la plantalla success en redux
        dispatch(userRegisterStep(steps));
      } else {
        dispatch(setMessageCreateUser(result.Message));
      }
    } else if (response.status === 400) {
      toast.isToastOpen = true;
      toast.msgToast = result.Message;
      // toast.msgToast = "El correo electrónico ingresado ya existe en nuestros registros. Intente nuevamente";
      toast.typeStyle = "error";
      dispatch(openCloseToast(toast));
    } else {
      toast.isToastOpen = true;
      toast.msgToast = "Error en la creación del usuario";
      toast.typeStyle = "error";
      toast.displayTime = 5000
      dispatch(openCloseToast(toast));
    }
  } catch (error) {
    console.log(`Error: ${error}`);
    trace.information("ERROR", error);
    toast.isToastOpen = true;
    toast.msgToast = "Error de conexión, intente más tarde";
    toast.typeStyle = "error";
    toast.displayTime = 5000
    dispatch(openCloseToast(toast));
  }
  dispatch(loading(false));
};

/**
 *  Envia el SMS al tlefono del usuario con el link de para
 *  la activación de cuentas
 * @param {*} userRegister Datos de registro del usuario
 * @returns boolean con status de si el sms fue enviado o no fue enviado
 */
export const sendSMSActivationAccount = (userRegister) => {
  //Acortar la URL para ajustarla al SMS userRegister.href
  // tinyURL.shorten(userRegister.urlCorreo, (res, err) => {
  //   const datosSMS = {
  //     To: userRegister.Phone,
  //     Message: `Bienvenido a ACHS Virtual. Para acceder, haz clic en el siguiente link ${res} y luego registra tu clave.`,
  //   };
  //   sendSMS(datosSMS)
  //     .then((response) => console.log({ response }))
  //     .catch((err) => {
  //       throw new Error(err);
  //     });
  // });
};
